import { useContentfulSelector } from '../../../redux/hooks';
import { selectPagesError } from '../../../redux/selectors';
const SectionState = ({ children }) => {
    const error = useContentfulSelector(selectPagesError);
    if (error)
        return null;
    return children;
};
export default SectionState;
